import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UpgradePrompt.css';

const UpgradePrompt = ({ feature, message, showBackButton = true }) => {
  const navigate = useNavigate();

  return (
    <div className="upgrade-prompt-overlay">
      <div className="upgrade-prompt-background">
        <div className="wave-pattern"></div>
      </div>
      <div className="upgrade-prompt-card">
        <div className="upgrade-prompt-icon">💎</div>
        <h2>Upgrade to Pro</h2>
        <p className="upgrade-prompt-feature">{feature} is a Pro feature</p>
        <p className="upgrade-prompt-message">
          {message || `Unlock ${feature} and everything else AirFlyp has to offer with a Pro subscription.`}
        </p>
        <div className="upgrade-prompt-benefits">
          <div className="benefit-item">✓ Unlimited clients</div>
          <div className="benefit-item">✓ AI Persona chatbot</div>
          <div className="benefit-item">✓ Video conferencing</div>
          <div className="benefit-item">✓ Coach analysis & insights</div>
          <div className="benefit-item">✓ Unlimited surveys</div>
          <div className="benefit-item">✓ Priority support</div>
        </div>
        <div className="upgrade-prompt-actions">
          <button className="upgrade-prompt-btn primary" onClick={() => navigate('/pricing')}>
            View Plans — Starting at $23/mo
          </button>
          {showBackButton && (
            <button className="upgrade-prompt-btn secondary" onClick={() => navigate('/dashboard')}>
              Back to Dashboard
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpgradePrompt;